export const BaseModel = {
  validator: undefined,
};

export function create(validator, props = {}) {
  return {
    ...BaseModel,
    validator,
    ...props,
  };
}

export function createAll(validators) {
  const validatorsList = (validators instanceof Array) ? validators : Array(validators);
  return validatorsList.map((validator) => {
    let props = undefined;
    if (Object.prototype.toString.call(validator) === '[object Object]') props = validator;
    return create(validator, props);
  });
}

export default {
  create,
  createAll,
};
